import { useState } from 'react';
import { toast } from 'react-toastify';
import { patchAPI } from '../services/api.service';
import { GroupCreateType } from '../Types/Group.type';
import { useFetchGroups } from './useFetchGroups';

export const useManageGroup = () => {
  const [loading, setLoading] = useState(false);
    const user = JSON.parse(localStorage.getItem('user') || '{}') as { id?: string };
  const { refetch: refetchGroups } = useFetchGroups(user?.id || '');

  const handleManageGroup = async (groupId: string, data: GroupCreateType) => {
    setLoading(true);
    try {
        const {_id,createdBy,createdAt,updatedAt,__v,participantsMerged,...rest} = data;
      const response = await patchAPI(`/groups/manage/${groupId}`, rest);

      if (response.status === 200) {

        setTimeout(() => {
          refetchGroups();
        }, 2200);
        toast.success('Group updated successfully!');

      } else {
        toast.error('Failed to update group.');
      }
    } catch (error) {
      toast.error('An error occurred while updating the group.');
    } finally {
      setLoading(false);
    }
  };

  return { handleManageGroup, loading };
};
